import { operatorGroupsModel } from './operator-groups-model'
import { z } from 'my-zod'

export const operatorGroupSystemView = operatorGroupsModel.augment({
  outfitterIds: z.number().array()
})

export type operatorGroupSystemView = z.infer<typeof operatorGroupSystemView>
